import { Routes, Route } from 'react-router-dom';
import Login from "./components/Login";
import Waiting from "./components/Waiting";
import RegisterUser from './components/Register';
import CalonAnggota from './pages/CalonAnggota';
import AnggotaIKDKI from './pages/AnggotaIKDKI';
import Institusi from './pages/Institusi';
import Reporting from './pages/Reporting';
import RequestEditUser from './pages/RequestEditUser';
import TabelPengabdian from './pages/TabelPengabdian';
import TabelPenelitian from './pages/TabelPenelitian';
import TabelPublikasi from './pages/TabelPublikasi';
import TabelPengajaran from './pages/TabelPengajaran';
import LogUser from './pages/LogUser';
import KonfirmasiEditUser from './pages/KonfirmasiEditUser';
import Unauthorized from './components/Unauthorized';
import { useAuth } from './components/AuthProvider';
import PageNotFound from './pages/PageNotFound';
import ResetPassword from './components/ResetPassword';
import ChangeUserPassword from './components/ChangeUserPassword';
import LandingPageRakernas from './components/LandingPageRakernas';
import RakernasWaitingRegister from './components/RakernasWaitingRegister';
import UserProfile from './pages/UserProfile';
import AjuanPembayaran from './pages/AjuanPembayaran';
import JenisIuran from './pages/JenisIuran';
import PembuatanVA from './pages/PembuatanVA';
import UploadVAReport from './pages/UploadVAReport';
import AdminDaerah from './pages/AdminDaerah';
import Layout from './pages/Layout';
import ManajemenRole from './pages/ManajemenRole';
import ManajemenMenuAkses from './pages/ManajemenMenuAkses';
import ManajemenRolePengguna from './pages/ManajemenRolePengguna';
import ActivityLog from './pages/ActivityLog';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// Recursively looks for `key` anywhere in the menu tree the backend resolved
// for this user's access role (see controller/AccessControl.js buildMenuTree).
const hasMenuAccess = (menus, key) =>
    menus.some((item) => item.key === key || (item.children && hasMenuAccess(item.children, key)));

const PageLoading = () => (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
    </Box>
);

function App() {
    const { isAuthenticated, authStatus, menus } = useAuth();
    // A route without a menuKey (e.g. the post-login dashboard) stays open to
    // any authenticated user, same as before this menu system existed.
    const guard = (menuKey, component) => {
        // Cookie-backed sessions can't be read synchronously on first render
        // (unlike the old localStorage token), so show a neutral loading
        // state instead of flashing PageNotFound while it resolves.
        if (authStatus === "loading") return <PageLoading />;
        if (!isAuthenticated) return <PageNotFound />;
        if (menuKey && !hasMenuAccess(menus, menuKey)) return <PageNotFound />;
        return component;
    };

    // Public routes: no sidebar/navbar chrome.
    const publicRoutes = [
        { path: "/", element: <Login /> },
        { path: "/reset-password", element: <ResetPassword /> },
        { path: "/waiting", element: <Waiting /> },
        { path: "/register", element: <RegisterUser /> },
        { path: "/change-user-password/:token", element: <ChangeUserPassword /> },
        { path: "/unauthorized", element: <Unauthorized /> },
        // Rakernas
        { path: "/tabel-pendaftaran-rakernas", element: <LandingPageRakernas /> },
        { path: "/pendaftaran-rakernas", element: <LandingPageRakernas /> },
        { path: "/success-rakernas-registration", element: <RakernasWaitingRegister /> },
    ];

    // App routes: share one persistent Layout (sidebar/navbar) via <Outlet/>,
    // instead of every page re-mounting its own copy.
    const layoutRoutes = [
        { path: "/calon-anggota", element: guard("calon-anggota", <CalonAnggota />) },
        { path: "/anggota", element: guard("anggota-ikdki", <AnggotaIKDKI />) },
        { path: "/institusi", element: guard("institusi", <Institusi />) },
        { path: "/reporting", element: guard("reporting", <Reporting />) },
        { path: "/edit-user", element: guard(null, <RequestEditUser />) },
        { path: "/tabel-pengabdian", element: guard("tabel-pengabdian", <TabelPengabdian />) },
        { path: "/tabel-penelitian", element: guard("tabel-penelitian", <TabelPenelitian />) },
        { path: "/tabel-publikasi", element: guard("tabel-publikasi", <TabelPublikasi />) },
        { path: "/tabel-pengajaran", element: guard("tabel-pengajaran", <TabelPengajaran />) },
        { path: "/loguser", element: guard(null, <LogUser />) },
        { path: "/update-confirmation/:requestId/:userId", element: guard(null, <KonfirmasiEditUser />) },
        { path: "/admin-daerah", element: guard("admin-daerah", <AdminDaerah />) },
        { path: "/member-card", element: guard("member-card", <UserProfile />) },
        { path: "/ajuan-pembayaran", element: guard("ajuan-pembayaran", <AjuanPembayaran />) },
        { path: "/jenis-iuran", element: guard("jenis-iuran", <JenisIuran />) },
        { path: "/pembuatan-va", element: guard("pembuatan-va", <PembuatanVA />) },
        { path: "/upload-va-report", element: guard("upload-va-report", <UploadVAReport />) },
        { path: "/manajemen-role", element: guard("manajemen-role", <ManajemenRole />) },
        { path: "/manajemen-menu-akses", element: guard("menu-akses", <ManajemenMenuAkses />) },
        { path: "/manajemen-role-pengguna", element: guard("role-pengguna", <ManajemenRolePengguna />) },
        { path: "/log-aktivitas", element: guard("log-aktivitas", <ActivityLog />) },
        { path: "*", element: <PageNotFound /> },
    ];

    return (
        <div>
            <Routes>
                {publicRoutes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                ))}

                <Route element={<Layout />}>
                    {layoutRoutes.map((route, index) => (
                        <Route key={index} path={route.path} element={route.element} />
                    ))}
                </Route>
            </Routes>
        </div>
    );
}

export default App;
